module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery6-67514568a27935167b792cba5408057a.jpg";